import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import Header from "../../components/Layout/Header";
import Sidebar from "../../components/Layout/Sidebar";
import Main from "../../components/Layout/Main";
import ShopsContext from "../../context/shops/shopsContext";
import Pagination from '../../components/Layout/Pagination';
import SweetAlertWrapper from "../../components/Layout/sweetAlert";
import { Button, Spinner, Card } from "react-bootstrap";

const ListPosSales = () => {
    const shopsContext = useContext(ShopsContext);
    const { listSales, sales, salesCount, products, listProducts, notification, clear_notification } = shopsContext;
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ text: "", type: "" });
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(salesCount / 10);
    console.log("Total Pages:", totalPages);
    console.log("Current Page:", currentPage);
    console.log("Sales Count:", salesCount);
    console.log("Sales Data:", sales);

    let [filters, setFilters] = useState({
        pageNumber: currentPage,
        pageSize: 15,
        DateCreated: new Date().toISOString().split('T')[0],
        ItemCode: "",
    });
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            pageNumber: currentPage,
        }));
    }, [currentPage]);


    useEffect(() => {
        console.log("tumeitwa")
        fetchData();
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        listProducts()
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    }, []);

    const fetchData = () => {
        console.log("Fetching data with filters:", filters);
        setLoading(true);
        listSales(filters.pageNumber, filters.pageSize, filters.DateCreated, filters.ItemCode)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleConfirm = () => {
        clear_notification();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const handleItemCodeChange = (selectedOption) => {
        setFilters({ ...filters, ItemCode: selectedOption ? selectedOption.value : "" });
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        fetchData();
    };

    return (
        <div className="niceadmin">
            <Header />
            <Sidebar page="List Customer" />
            <Main>
                <SweetAlertWrapper
                    show={showAlert}
                    title="Notification"
                    message={alertMessage.text}
                    onConfirm={handleConfirm}
                    confirmBtnText="OK"
                    type={alertMessage.type || "info"}
                />

                <Card className="p-4">
                    <h5 className="mb-3">List Sales</h5>

                    <form onSubmit={handleFilterSubmit} className="mb-4">
                        <div className="row align-items-end">
                            <div className="col-md-6">
                                <label htmlFor="DateCreated" className="form-label">
                                    Date Created
                                </label>
                                <input
                                    type="date"
                                    name="DateCreated"
                                    id="DateCreated"
                                    value={filters.DateCreated}
                                    onChange={handleInputChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="ItemCode" className="form-label">
                                    Product
                                </label>
                                <Select
                                    id="ItemCode"
                                    name="ItemCode"
                                    value={
                                        filters.ItemCode
                                            ? {
                                                value: filters.ItemCode,
                                                label: products.find(
                                                    (product) => product.itemCode === filters.ItemCode
                                                )?.itemName || "",
                                            }
                                            : null
                                    }
                                    onChange={handleItemCodeChange}
                                    options={products.map((product) => ({
                                        value: product.itemCode,
                                        label: product.itemName,
                                    }))}
                                    placeholder="Select Product"
                                    isClearable
                                />
                            </div>
                        </div>

                        {/* <div className="mt-3 text-end">
                            <Button type="submit" variant="primary">
                                Apply Filters
                            </Button>
                        </div> */}
                    </form>

                    {loading ? (
                        <div className="text-center my-3">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th> Transaction ID </th>
                                        <th>Vehicle Registration</th>
                                        <th>Product</th>
                                        <th>Quantity</th>
                                        <th>Price</th>
                                        <th>Payment Method</th>
                                        <th>Total Amount</th>
                                        <th>Payment Reference</th>
                                        <th>Station Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sales.length > 0 ? (
                                        sales.map((sale, index) => (
                                            <tr key={index}>
                                                <td>{sale.transactionId}</td>
                                                <td>{sale.vehicleRegistrationNumber}</td>
                                                <td>{sale.itemName}</td>
                                                <td>{sale.quantity}</td>
                                                <td>{sale.price}</td>
                                                <td>{sale.paymentMethod}</td>
                                                <td>{sale.totalAmount}</td>
                                                <td>{sale.mpesaReference}</td>
                                                <td>{sale.stationName}</td>

                                                <td>
                                                    <button className="btn btn-custom-actions dropdown-toggle">
                                                        Actions
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                No Records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {totalPages > 1 && (
                                <Pagination
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}

                                />
                            )}
                        </>
                    )}
                </Card>
            </Main>
        </div>
    );
};

export default ListPosSales;